

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"width":"13","height":"13","viewBox":"0 0 13 13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, rest), ["\n", h('g', {"clip-path":"url(#svg-plane-departure-2g9gfMx)"}, ["\n", h('path', {"d":"M11.7726 10.6761H0.528198V11.8597H11.7726V10.6761Z","fill":"#342245"}, []), "\n", h('path', {"d":"M12.11 5.13374C11.9828 4.66029 11.4975 4.37918 11.0241 4.50642L7.87858 5.34974L3.79506 1.54144L2.65287 1.84917L5.10298 6.09542L2.16167 6.88254L0.998757 5.96818L0.140625 6.19901L1.21773 8.06619L1.67047 8.85033L2.62034 8.59585L5.76583 7.75251L8.33725 7.06305L11.4827 6.21971C11.9562 6.09247 12.2373 5.6072 12.11 5.13374Z","fill":"#342245"}, []), "\n"]), "\n", h('defs', {}, ["\n", h('clipPath', {"id":"svg-plane-departure-2g9gfMx"}, ["\n", h('rect', {"width":"12","height":"12","fill":"white","transform":"translate(0.140625 0.700562)"}, []), "\n"]), "\n"]), "\n"]);
};

        